export default "__VITE_ASSET__MuvcDC6Q__"